import apiFetch from '@scale/frontend-lib/api-fetch';
import { useAsync } from 'react-use-v13';

interface BackendDefined {
  name: string;
  pageTitle: string;
}
type CacheDefinedPage = Promise<{ backendDynamicCorpPageTitles: BackendDefined[] }>;
const backendDefinedCache: { cache?: CacheDefinedPage } = {};
export const useCachedBackendDefinedCorpPages = () => {
  return useAsync(async () => {
    const promise: CacheDefinedPage =
      backendDefinedCache.cache ||
      apiFetch(null, `corp-api/dynamic-corp/backend-defined`, {
        method: 'GET',
      });
    backendDefinedCache.cache = promise;
    const { backendDynamicCorpPageTitles } = await promise;
    return backendDynamicCorpPageTitles;
  }, []);
};
